import './ZoomControls.scss'

import { HDSButton } from '@here/hds-react-components'
import React from 'react'

export enum ZoomAction {
  zoomIn,
  zoomOut,
}

interface MapZoomControlsProps {
  handleZoomChange: (zoomAction: ZoomAction) => void
}

export default function ZoomControls({ handleZoomChange }: MapZoomControlsProps): JSX.Element {
  // "variant: 'subtle'" sets background-color to white but also sets icon color to grey
  // "variant: 'danger'" sets background-color to dark red, which is a temporary way to express an error through UI
  return (
    <div className="ZoomControls__group">
      <HDSButton
        icon="plus"
        size="medium"
        variant="subtle"
        onClick={() => handleZoomChange(ZoomAction.zoomIn)}
      />
      <HDSButton
        icon="minus"
        size="medium"
        variant="subtle"
        onClick={() => handleZoomChange(ZoomAction.zoomOut)}
      />
    </div>
  )
}
